// HKDSE 2018 Paper 1 Knowledge Graph Samples - Complete Set
// Organized by question types with systematic naming

export const hkdse2018Samples_complete = {
  algebra: [
    {
      id: 'hkdse2018_algebra_01',
      problem: "Given that $b$ is the subject of the formula $\\frac{a+4}{3} = \\frac{b+1}{2}$.",
      problemType: "algebra_formula",
      difficulty: "fundamental",
      description: "Rearranging formula to make a variable the subject",
      graphData: {
        nodes: [
          {
            id: "fraction_equation",
            name: "Fraction Equation",
            type: "concepts",
            description: "Equation with fractions on both sides",
            value: "(a+4)/3 = (b+1)/2",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "cross_multiplication",
            name: "Cross Multiplication",
            type: "concepts",
            description: "Method to eliminate fractions",
            value: "If a/b = c/d, then ad = bc",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_cross_multiply",
            name: "Step 1: Cross Multiply",
            type: "steps",
            description: "Multiply both sides by 6",
            value: "2(a+4) = 3(b+1)",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_expand",
            name: "Step 2: Expand",
            type: "steps",
            description: "Expand both sides",
            value: "2a + 8 = 3b + 3",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step3_collect_terms",
            name: "Step 3: Collect Terms",
            type: "steps",
            description: "Move b terms to one side",
            value: "2a + 5 = 3b",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "step4_solve_for_b",
            name: "Step 4: Solve for b",
            type: "steps",
            description: "Divide by 3",
            value: "b = (2a + 5)/3",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "b expressed in terms of a",
            value: "b = (2a + 5)/3",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "fraction_equation", to: "cross_multiplication", type: "requires", strength: 9 },
          { from: "cross_multiplication", to: "step1_cross_multiply", type: "enables", strength: 10 },
          { from: "step1_cross_multiply", to: "step2_expand", type: "leads to", strength: 8 },
          { from: "step2_expand", to: "step3_collect_terms", type: "leads to", strength: 8 },
          { from: "step3_collect_terms", to: "step4_solve_for_b", type: "leads to", strength: 9 },
          { from: "step4_solve_for_b", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'hkdse2018_algebra_02',
      problem: "Simplify $\\frac{xy^7}{(x^{-2}y^3)^4}$ and express the answer in positive index form.",
      problemType: "algebra_indices",
      difficulty: "intermediate",
      description: "Simplifying expressions with negative indices",
      graphData: {
        nodes: [
          {
            id: "negative_indices",
            name: "Negative Indices",
            type: "concepts",
            description: "Understanding negative indices and their properties",
            value: "a⁻ⁿ = 1/aⁿ",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "power_of_power",
            name: "Power of Power",
            type: "concepts",
            description: "When raising a power to another power, multiply the indices",
            value: "(aᵐ)ⁿ = aᵐⁿ",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "division_of_powers",
            name: "Division of Powers",
            type: "concepts",
            description: "When dividing powers with the same base, subtract the indices",
            value: "aᵐ ÷ aⁿ = aᵐ⁻ⁿ",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_simplify_denominator",
            name: "Step 1: Simplify Denominator",
            type: "steps",
            description: "Apply power of power rule to (x⁻²y³)⁴",
            value: "(x⁻²y³)⁴ = x⁻⁸y¹²",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_divide",
            name: "Step 2: Divide",
            type: "steps",
            description: "Divide xy⁷ by x⁻⁸y¹²",
            value: "xy⁷ ÷ (x⁻⁸y¹²) = x⁹y⁻⁵",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "step3_convert_negative",
            name: "Step 3: Convert to Positive Indices",
            type: "steps",
            description: "Convert negative indices to positive using reciprocal",
            value: "x⁹y⁻⁵ = x⁹/y⁵",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "The simplified expression in positive indices",
            value: "x⁹/y⁵",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "power_of_power", to: "step1_simplify_denominator", type: "enables", strength: 9 },
          { from: "division_of_powers", to: "step2_divide", type: "enables", strength: 9 },
          { from: "step1_simplify_denominator", to: "step2_divide", type: "enables", strength: 9 },
          { from: "step2_divide", to: "step3_convert_negative", type: "leads to", strength: 10 },
          { from: "negative_indices", to: "step3_convert_negative", type: "enables", strength: 10 },
          { from: "step3_convert_negative", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  rounding: [
    {
      id: 'hkdse2018_rounding_01',
      problem: "(a) Round $265.473$ to the nearest integer. (b) Round $265.473$ down to one decimal place. (c) Round $265.473$ to two significant figures.",
      problemType: "rounding_significant_figures",
      difficulty: "fundamental",
      description: "Working with different types of rounding",
      graphData: {
        nodes: [
          {
            id: "rounding_concepts",
            name: "Rounding Concepts",
            type: "concepts",
            description: "Understanding different rounding methods",
            value: "Nearest, down, significant figures",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_nearest_integer",
            name: "Part (a): Nearest Integer",
            type: "steps",
            description: "Round 265.473 to nearest integer",
            value: "Look at decimal part: 0.473 < 0.5",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "part_a_result",
            name: "Part (a): Result",
            type: "steps",
            description: "Since 0.473 < 0.5, round down",
            value: "265.473 → 265",
            importance: 8,
            x: -200, y: 100, z: -15
          },
          {
            id: "part_b_round_down",
            name: "Part (b): Round Down",
            type: "steps",
            description: "Round 265.473 down to 1 decimal place",
            value: "Always round down to 265.4",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_c_significant_figures",
            name: "Part (c): Significant Figures",
            type: "steps",
            description: "Round 265.473 to 2 significant figures",
            value: "First 2 digits: 2,6",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_c_calculation",
            name: "Part (c): Calculation",
            type: "steps",
            description: "Calculate 2 significant figures",
            value: "265.473 → 270",
            importance: 8,
            x: 200, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 265 (b) 265.4 (c) 270",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "rounding_concepts", to: "part_a_nearest_integer", type: "enables", strength: 8 },
          { from: "rounding_concepts", to: "part_b_round_down", type: "enables", strength: 8 },
          { from: "rounding_concepts", to: "part_c_significant_figures", type: "enables", strength: 8 },
          { from: "part_a_nearest_integer", to: "part_a_result", type: "leads to", strength: 8 },
          { from: "part_b_round_down", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_c_significant_figures", to: "part_c_calculation", type: "leads to", strength: 8 },
          { from: "part_a_result", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_c_calculation", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  probability: [
    {
      id: 'hkdse2018_probability_01',
      problem: "A box contains $n$ white balls, $5$ black balls and $8$ red balls. If a ball is randomly drawn from the box, the probability of drawing a red ball is $\\frac{2}{5}$. Find the value of $n$.",
      problemType: "probability_basic",
      difficulty: "intermediate",
      description: "Solving probability problems with unknown quantities",
      graphData: {
        nodes: [
          {
            id: "probability_concept",
            name: "Probability Concept",
            type: "concepts",
            description: "Understanding probability formula",
            value: "P(event) = favorable/total",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_probability",
            name: "Given Probability",
            type: "concepts",
            description: "P(red ball) = 2/5",
            value: "Use to find total balls",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "total_balls",
            name: "Total Balls",
            type: "concepts",
            description: "Total balls in box",
            value: "Total = n + 5 + 8 = n + 13",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_setup_equation",
            name: "Step 1: Setup Equation",
            type: "steps",
            description: "Set up probability equation",
            value: "8/(n + 13) = 2/5",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_cross_multiply",
            name: "Step 2: Cross Multiply",
            type: "steps",
            description: "Cross multiply to eliminate fraction",
            value: "8 × 5 = 2 × (n + 13)",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "step3_simplify",
            name: "Step 3: Simplify",
            type: "steps",
            description: "Simplify the equation",
            value: "40 = 2n + 26",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "step4_solve",
            name: "Step 4: Solve for n",
            type: "steps",
            description: "Solve the linear equation",
            value: "14 = 2n → n = 7",
            importance: 9,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Value of n",
            value: "n = 7",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "probability_concept", to: "step1_setup_equation", type: "enables", strength: 9 },
          { from: "given_probability", to: "step1_setup_equation", type: "enables", strength: 9 },
          { from: "total_balls", to: "step1_setup_equation", type: "enables", strength: 8 },
          { from: "step1_setup_equation", to: "step2_cross_multiply", type: "leads to", strength: 8 },
          { from: "step2_cross_multiply", to: "step3_simplify", type: "leads to", strength: 8 },
          { from: "step3_simplify", to: "step4_solve", type: "leads to", strength: 9 },
          { from: "step4_solve", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  factorization: [
    {
      id: 'hkdse2018_factorization_01',
      problem: "Factorize: (a) $9r^3 - 18r^2s$ (b) $9r^3 - 18r^2s - rs^2 + 2s^3$",
      problemType: "factorization",
      difficulty: "intermediate",
      description: "Factorization of expressions with multiple variables",
      graphData: {
        nodes: [
          {
            id: "common_factor",
            name: "Common Factor",
            type: "concepts",
            description: "Finding common factors in terms",
            value: "ab + ac = a(b + c)",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "grouping_method",
            name: "Grouping Method",
            type: "concepts",
            description: "Method for factoring by grouping",
            value: "Group terms with common factors",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_common_factor",
            name: "Part (a): Common Factor",
            type: "steps",
            description: "Factor out common factor 9r²",
            value: "9r³ - 18r²s = 9r²(r - 2s)",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "part_b_rearrange",
            name: "Part (b): Rearrange",
            type: "steps",
            description: "Rearrange to use part (a)",
            value: "(9r³ - 18r²s) + (-rs² + 2s³)",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "part_b_group_factor",
            name: "Part (b): Group and Factor",
            type: "steps",
            description: "Factor by grouping",
            value: "9r²(r - 2s) + s²(-r + 2s)",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_final",
            name: "Part (b): Final Answer",
            type: "steps",
            description: "Factor out common factor",
            value: "(r - 2s)(9r² - s²)",
            importance: 9,
            x: 200, y: 0, z: 25
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 9r²(r - 2s) (b) (r - 2s)(9r² - s²)",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "common_factor", to: "part_a_common_factor", type: "enables", strength: 8 },
          { from: "grouping_method", to: "part_b_group_factor", type: "enables", strength: 9 },
          { from: "part_a_common_factor", to: "part_b_rearrange", type: "enables", strength: 8 },
          { from: "part_b_rearrange", to: "part_b_group_factor", type: "leads to", strength: 9 },
          { from: "part_b_group_factor", to: "part_b_final", type: "leads to", strength: 9 },
          { from: "part_a_common_factor", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_final", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ]
}; 